function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
export var ChevronUp = function ChevronUp(_ref) {
  var _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === void 0 ? 2 : _ref$strokeWidth,
      strokeLineCap = _ref.strokeLineCap;
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4248 8.5752L7.5 1.65039L0.575196 8.5752",
    stroke: "inherit",
    fill: "none",
    strokeWidth: strokeWidth,
    strokeLinecap: strokeLineCap
  }));
};
export var ChevronDown = function ChevronDown(_ref2) {
  var _ref2$strokeWidth = _ref2.strokeWidth,
      strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth,
      strokeLineCap = _ref2.strokeLineCap;
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.868652 7.86719L7.93972 14.9383L15.0108 7.86719",
    stroke: "inherit",
    fill: "none",
    strokeWidth: strokeWidth,
    strokeLinecap: strokeLineCap
  }));
};
export var ChevronLeft = function ChevronLeft(_ref3) {
  var _ref3$strokeWidth = _ref3.strokeWidth,
      strokeWidth = _ref3$strokeWidth === void 0 ? 2 : _ref3$strokeWidth,
      strokeLineCap = _ref3.strokeLineCap;
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 14 14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.94971 2L1.99996 6.94975L6.94971 11.8995",
    stroke: "inherit",
    fill: "none",
    strokeWidth: strokeWidth,
    strokeLinecap: strokeLineCap
  }));
};
export var ChevronRight = function ChevronRight(_ref4) {
  var _ref4$strokeWidth = _ref4.strokeWidth,
      strokeWidth = _ref4$strokeWidth === void 0 ? 2 : _ref4$strokeWidth,
      strokeLineCap = _ref4.strokeLineCap;
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 14 14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.94922 11.8994L11.899 6.94967L6.94922 1.99992",
    stroke: "inherit",
    fill: "none",
    strokeWidth: strokeWidth,
    strokeLinecap: strokeLineCap
  }));
};
export var Chevron = ChevronUp;
export var AdvisorChevronUp = function AdvisorChevronUp(_ref5) {
  var _ref5$strokeWidth = _ref5.strokeWidth,
      strokeWidth = _ref5$strokeWidth === void 0 ? 1 : _ref5$strokeWidth,
      props = _objectWithoutProperties(_ref5, ["strokeWidth"]);

  return /*#__PURE__*/React.createElement(ChevronUp, _extends({}, props, {
    strokeWidth: strokeWidth
  }));
};
export var AdvisorChevronDown = function AdvisorChevronDown(_ref6) {
  var _ref6$strokeWidth = _ref6.strokeWidth,
      strokeWidth = _ref6$strokeWidth === void 0 ? 1 : _ref6$strokeWidth,
      props = _objectWithoutProperties(_ref6, ["strokeWidth"]);

  return /*#__PURE__*/React.createElement(ChevronDown, _extends({}, props, {
    strokeWidth: strokeWidth
  }));
};
export var AdvisorChevronLeft = function AdvisorChevronLeft(_ref7) {
  var _ref7$strokeWidth = _ref7.strokeWidth,
      strokeWidth = _ref7$strokeWidth === void 0 ? 1 : _ref7$strokeWidth,
      props = _objectWithoutProperties(_ref7, ["strokeWidth"]);

  return /*#__PURE__*/React.createElement(ChevronLeft, _extends({}, props, {
    strokeWidth: strokeWidth
  }));
};
export var AdvisorChevronRight = function AdvisorChevronRight(_ref8) {
  var _ref8$strokeWidth = _ref8.strokeWidth,
      strokeWidth = _ref8$strokeWidth === void 0 ? 1 : _ref8$strokeWidth,
      props = _objectWithoutProperties(_ref8, ["strokeWidth"]);

  return /*#__PURE__*/React.createElement(ChevronRight, _extends({}, props, {
    strokeWidth: strokeWidth
  }));
};
export var AdvisorChevron = AdvisorChevronUp;